import { ExclusionListSelectorController } from '../controller/ExclusionListSelectorController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { List } from '../../exclusionsPanel/types';

export class ExclusionListSelectorWebComponent extends BaseWebComponentElement {
  private onExclusionListClickedFn?: (clickedExclusionList: List) => Promise<void>;
  private onExclusionListChangedWithSuccessFn?: () => Promise<void>;
  private onExclusionListChangedWithErrorFn?: (error: Error) => Promise<void>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ExclusionListSelectorController,
    });
  }

  set onExclusionListClicked(onExclusionListClickedFn: ((clickedExclusionList: List) => Promise<void>) | undefined) {
    this.onExclusionListClickedFn = onExclusionListClickedFn;
  }

  get onExclusionListClicked(): ((clickedExclusionList: List) => Promise<void>) | undefined {
    return this.onExclusionListClickedFn;
  }

  set onExclusionListChangedWithSuccess(onExclusionListChangedWithSuccessFn: (() => Promise<void>) | undefined) {
    this.onExclusionListChangedWithSuccessFn = onExclusionListChangedWithSuccessFn;
  }

  get onExclusionListChangedWithSuccess(): (() => Promise<void>) | undefined {
    return this.onExclusionListChangedWithSuccessFn;
  }

  set onExclusionListChangedWithError(
    onExclusionListChangedWithErrorFn: ((error: Error) => Promise<void>) | undefined
  ) {
    this.onExclusionListChangedWithErrorFn = onExclusionListChangedWithErrorFn;
  }

  get onExclusionListChangedWithError(): ((error: Error) => Promise<void>) | undefined {
    return this.onExclusionListChangedWithErrorFn;
  }

  get selectedTarget(): List {
    const value = this.getAttribute('data-selected-target');
    return value ? JSON.parse(value) : [];
  }

  set selectedTarget(value) {
    if (!value) {
      return;
    }
    this.setAttribute('data-selected-target', JSON.stringify(value));
  }

  get exclusionList(): Array<List> {
    return this.getValueFromAttribute(this, 'data-exclusion-lists', []);
  }

  set exclusionList(value) {
    if (!value) {
      return;
    }
    this.setAttribute('data-exclusion-lists', JSON.stringify(value));
  }

  set disabled(value: boolean) {
    this.setAttribute('data-is-disabled', JSON.stringify(value ? true : false));
  }

  get disabled(): boolean {
    const value = this.getAttribute('data-is-disabled');
    return value ? JSON.parse(value) : false;
  }

  set exclusionListSelectorParams(value: List) {
    if (!value) {
      return;
    }

    this.setAttribute('data-ExclusionList-selector-params', JSON.stringify(value));
  }

  get exclusionListSelectorParams(): List {
    const value = this.getAttribute('data-ExclusionList-selector-params');
    return value ? JSON.parse(value) : {};
  }
}
